import styles from './RefundReason.css'
class RefundReason extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      reasonForRefund: '',
      otherReasonForRefund: ''
    }
  }
  render () {
    return (<div className='row'>
      <div className='col-md-12'>
        <label className='refund-reason'>{this.props.labelReason}</label>
        <select className='form-control' onChange={this._onChangeReasonForRefund} defaultValue={this.state.reasonForRefund}>
          <option value=''>- Select Reason -</option>
          <option value='Returned Goods'>Returned Goods</option>
          <option value='Accidental Charge'>Accidental Charge</option>
          <option value='Cancelled Order'>Cancelled Order</option>
          <option value='Other'>Other</option>
        </select>
      </div>
      {this.state.reasonForRefund === 'Other' && <div className='col-md-12'>
        <input type='text'
          value={this.state.otherReasonForRefund}
          onChange={this._onChangeOtherReasonForRefund}
          placeholder='Reason for refund'
          className={`form-control ${styles['other-reason']}`} />
      </div>}
    </div>)
  }

  _onChangeReasonForRefund = (e) => {
    let value = e.target.value
    this.setState({reasonForRefund: value})
    this.props.onChangeReasonForRefund(value)
  };

  _onChangeOtherReasonForRefund = (e) => {
    let value = e.target.value
    this.setState({otherReasonForRefund: value})
    this.props.onChangeOtherReasonForRefund(value)
  }
}

RefundReason.propTypes = {
  // onChangeReasonForRefund(newValue)
  onChangeReasonForRefund: React.PropTypes.func,
  // onChangeOtherReasonForRefund(newValue)
  onChangeOtherReasonForRefund: React.PropTypes.func,
  labelReason: React.PropTypes.string
}

export default RefundReason



// WEBPACK FOOTER //
// ./app/components/receipt/refunds/RefundReason/RefundReason.js